import { useMutation } from "@tanstack/react-query";
import { postLinkHealthFacility } from "apis";
import queryClient from "../../../instances/react-query-client";
import { getMyProfileQueryKeys } from "../get-my-profile";

const usePostLinkHealthFacility = () => {
  return useMutation({
    mutationFn: postLinkHealthFacility,
    onSuccess: ({ success }) => {
      if (success) {
        queryClient.invalidateQueries(getMyProfileQueryKeys());
      }
    },
  });
};

export default usePostLinkHealthFacility;
